import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { RouterProvider } from 'react-router-dom';

import App from './app';
import './index.css';
import router from './router';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <>
    {/* <React.StrictMode> */}
    <HelmetProvider>
      <App>
        <RouterProvider router={router} />
      </App>
    </HelmetProvider>
    {/* </React.StrictMode> */}
  </>,
);
